import axios from "axios";
import { API_URL } from "../../constants";

export default {
    getAllCommunicationType: () => {
        return axios.get(API_URL.COMMUNICATION_TYPE, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    getAllCommunicationPlan: (page, pageSize) => {
        return axios.get(API_URL.COMMUNICATION_TYPE_PLAN, {

            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
            params: {
                page: page,
                pageSize: pageSize,
            },
        });
    },


    createCommunicationPlancreate: (data) => {
        return axios.post(`${API_URL.COMMUNICATION_TYPE_PLAN}`, data, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    communicationProductMappingcreate: (data) => {
        return axios.post(`${API_URL.COMMUNICATION_TYPE_PRODUCTMAPPING}`, data, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },
    communicationProductMappingEdit: (id, data) => {

        return axios.patch(`${API_URL.COMMUNICATION_TYPE_PRODUCTMAPPING}/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },
    communicationProductMappingDelete: (id) => {

        return axios.delete(`${API_URL.COMMUNICATION_TYPE_PRODUCTMAPPING}/${id}`, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    getcommunicationProductMapping: () => {
        return axios.get(API_URL.COMMUNICATION_TYPE_PRODUCTMAPPING, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    getAllPricing: (page, pageSize, communication_type_uuid, plan_uuid) => {
        return axios.get(API_URL.COMMUNICATION_TYPE_PRODUCTMAPPING, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
            params: {
                page: page,
                pageSize: pageSize,
                communication_type_uuid,
                plan_uuid,
            },
        });
    },


};


